import React from 'react'

import { getErrorMessage } from 'utils'

import { useSnackbar } from 'contexts'
import { useCompanyMutationsQuery } from 'hooks/api'

import { Stack, Typography } from '@mui/material'

import { Modal, Button } from '@repo/ui'
import type { Company } from 'types'

interface ArchiveCompanyModalProps {
  company: Company | null
  open: boolean
  onClose: () => void
  refetch: () => void
}

export const ArchiveCompanyModal = (props: ArchiveCompanyModalProps) => {
  const { company, open, onClose = () => {}, refetch } = props

  const { open: notification } = useSnackbar()

  const { archive, isLoading } = useCompanyMutationsQuery({
    onSuccess: () => {
      onClose()
      refetch()
    },
    onError: error => {
      const message = getErrorMessage(error)
      notification({
        type: 'error',
        title: message,
      })
    },
  })

  const handleArchive = () => {
    if (!company?.id) return
    archive({ companyId: company.id })
  }

  return (
    <Modal
      title="Archive company"
      open={open}
      onClose={onClose}
      actions={
        <>
          <Button
            disableElevation
            variant="secondary"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </Button>

          <Button
            disableElevation
            onClick={handleArchive}
            disabled={isLoading}
          >
            {isLoading ? 'Archiving...' : 'Archive'}
          </Button>
        </>
      }
    >
      <Stack spacing="16px">
        <Typography variant="body2" color="text.secondary">
          Archive <strong>{company?.name}</strong>? The company will be hidden from the
          default list. You can reveal archived companies with the &ldquo;Show Archived&rdquo; toggle
          and unarchive at any time.
        </Typography>
      </Stack>
    </Modal>
  )
}
